<!--
 * @description: 红包雨我的奖励页
 * @Author: WE1ZHANTA0
 * @Creat: 2020-03-04 10:07:19
 * @lastTime: 2020-03-26 14:51:53
 * @LastAuthor: WE1ZHANTA0
 -->
<template>
  <div class="redPacket">
    <div class="listItem" v-for="(item, index) in listData" :key="index">
      <div class="left">
        <div class="descBox">
          <div class="price"><span class="icon">￥</span><span class="num">{{item.denomination}}</span></div>
          <div class="desc" v-if="item.prizeUseVaule">满{{item.prizeUseVaule}}可用</div>
        </div>
      </div>
      <div class="right">
        <div class="btn" @click="goUse(item)">立即使用</div>
      </div>
      <div class="mid">
        <div class="content">
          <div class="top">
            <div class="tips"><span>{{prizeKindArr[item.prizeKind - 1]}}</span></div>
            <div class="name">
              {{item.prizeName}}
            </div>
          </div>
          <!-- 云币  并且没有开始活动时间 -->
          <div class="bottom" v-if="item.prizeKind === 2 && (!item.prizeStartTime || !item.prizeEndTime)">
            {{item.coinTimeDesc}}
          </div>
          <div class="bottom" v-else>
            有效期 {{formatNew(item.prizeStartTime)}}-{{formatNew(item.prizeEndTime)}}
          </div>
        </div>
      </div>
    </div>
    <div class="isNoData" v-if="!listData || listData.length === 0">暂无奖励</div>
    <awardLimit v-show="showLimit" @awardRefresh='awardRefresh'></awardLimit>
  </div>
</template>
   
<script>
import { Toast, Indicator } from 'mint-ui'
import * as Http from '@/pages/commodity/api/redPacket'
import YunJi from '@/assets/js/YunJi'
import awardLimit from './awardLimit.vue'


export default {
  components: { awardLimit },
  data() {
    return {
      appCont: parseFloat(YunJi.getUrlParams('appCont')) || 0,
      shopId: YunJi.getUrlParams('shopId'),
      actId: YunJi.getUrlParams('actId'), // 活动id
      pageId: '', 
      prizeKindArr: ['优惠券', '云币', '游戏奖品'],
      showLimit: false,
      listData: [
        // {
        //   denomination: 0,
        //   prizeEndTime: 1234234924892,
        //   prizeId: 0,
        //   prizeKind: 0,
        //   prizeLink: '',
        //   prizeLinkType: 0,
        //   prizeName: 'jheef',
        //   prizeStartTime: 13248237483249,
        //   prizeUseVaule: 0
        // }
      ]
    }
  },
  created() {
    this.getPageId()
    this.queryData()
  },
  methods: {
    awardRefresh() {
      this.showLimit = false
      this.queryData()
    },
    formatNew(value) {
      return YunJi.formatNew(value, 'yyyy.MM.dd')
    },
    /**
     * 获取页面id
     */
    getPageId() {
      if (this.appCont === 1) {
        this.pageId = '80480'
      } else if (this.appCont === 2) {
        this.pageId = '80481'
      } else {
        this.pageId = '80482'
      }
    },
    /**
     * @description: 去使用
     */
    goUse(item) {
      let ponitId = ''
      if (this.appCont === 1) {
        ponitId = 24415
      } else if (this.appCont === 2) {
        ponitId = 24413
      } else {
        ponitId = 24414
      }
      // 埋点
      window.thinkingReport.track('other', {
        page_id: this.pageId,
        point_id: ponitId,
        operation_name: 'btn_奖励使用',
        activity_id: this.actId
      })
      // 要延时跳转不然埋点不上报
      setTimeout(() => {
        // 云币只跳专题
        if (item.prizeKind === 2) {
          if (this.appCont == 1 || this.appCont == 2) {
            window.location.href = `yunji://doubleTwelve/subject?subjectId=${item.prizeLink}`
          } else {
            if(this.appCont == 7){
              wx.miniProgram.navigateTo({ url: `/pages/subject/subject?subjectId=${item.prizeLink}` })
            }else{
              window.location.href = `//${window.globalConfig.buyerBasePath}/yj/subject?subjectId=${item.prizeLink}&shopId=${this.shopId}&appCont=${this.appCont}`
            }
          }
          return
        }
        // 优惠券根据type跳转
        // app
        if (this.appCont == 1 || this.appCont == 2) {
          if (item.prizeLinkType == 1) { // 专题
            window.location.href = `yunji://doubleTwelve/subject?subjectId=${item.prizeLink}`
          } else if (item.prizeLinkType == 2) { // 商详
            window.location.href = `yunji://doubleTwelve/itemDetail?itemId=${item.prizeLink}`
          } else if (item.prizeLinkType == 3) { // 品牌团
            window.location.href = `yunji://common/goBrandGroup?brandId=${item.prizeLink}`
          } else { // 首页 - 默认
            window.location.href = 'yunji://common/goHome'
          }
          return
        }
        if(this.appCont == 7){
          if (item.prizeLinkType == 1) { // 专题
            window.location.href = `//${window.globalConfig.buyerBasePath}/yj/subject?subjectId=${item.prizeLink}&shopId=${this.shopId}&appCont=${this.appCont}&ticket=${YunJi.getUrlParams('ticket') || ''}`
          }else if (item.prizeLinkType == 2) { // 商详
           wx.miniProgram.navigateTo({  
              url: `/pages/detail/detail?itemId=${item.prizeLink}&shopId=${this.shopId}&yunjiweidian=1&isPreview=0&sourceType=8001`
            })
          } else if (item.prizeLinkType == 3) { // 品牌团
            window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/brand-list?brandId=${item.prizeLink}&shopId=${this.shopId}&appCont=${this.appCont}&ticket=${YunJi.getUrlParams('ticket') || ''}`
          } else { // 首页 - 默认
           wx.miniProgram.switchTab({  
              url: `/pages/index/index`
            })
          } 
          return
        }
        // h5 YunJi
        if (item.prizeLinkType == 1) { // 专题
          window.location.href = `//${window.globalConfig.buyerBasePath}/yj/subject?subjectId=${item.prizeLink}&shopId=${this.shopId}&appCont=${this.appCont}&ticket=${YunJi.getUrlParams('ticket') || ''}`
        } else if (item.prizeLinkType == 2) { // 商详
          window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/detail?itemId=${item.prizeLink}&shopId=${this.shopId}&appCont=${this.appCont}&ticket=${YunJi.getUrlParams('ticket') || ''}`
        } else if (item.prizeLinkType == 3) { // 品牌团
          window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/brand-list?brandId=${item.prizeLink}&shopId=${this.shopId}&appCont=${this.appCont}&ticket=${YunJi.getUrlParams('ticket') || ''}`
        } else { // 首页 - 默认
          window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/more?shopId=${this.shopId}&appCont=${this.appCont}`
        }
      }, 200);
      
    }, 
    /**
     * @description: 查询数据
     */
    queryData() {
      Indicator.open()
      // setTimeout(() => {
      //   Indicator.close()
      //   this.showLimit = true
      // }, 1000)
      // return
      Http.getMyPrizeList({
        appCont: this.appCont,
        shopId: this.shopId,
        actId: this.actId,
        ...this.appCont === 7 ? { ticket: YunJi.getUrlParams('ticket') || '' } : ''
      }).then((res) => {
        Indicator.close()
        if (res.errorCode === 0) {
          if (res.data) {
            this.listData = res.data
          }
        } else if (res.errorCode === -99999) { // 限流
          this.showLimit = true
        } else {
          Toast(res.errorMessage)
        }
      })
        .catch(() => {
          Indicator.close()
        })
    }
  }
}
</script>
  
<style lang='less' scoped>
.redPacket{
  padding: 0.26rem 0.32rem 0 0.32rem;
  box-sizing: border-box;
  width: 100%;
  .listItem{
    width: 100%;
    height: 1.38rem;
    background: #FEF3F3;
    border: 0.01rem solid #FEE0DF;
    border-radius: 0.08rem;
    margin-bottom: 0.16rem;
    padding: 0.17rem 0 0.142rem 0;
    .left{
      float: left;
      width: 1.6rem;
      height: 100%;
      box-sizing: border-box;
      border-right: 0.02rem solid #FEDFDE;
      display: flex;
      justify-content: center;
      align-items: center;
      .descBox{
        .price{
          font-family: PingFangSC-Semibold;
          text-align: center;
          .icon{
            font-size: 0.24rem;
            color: #EE2325;
          }
          .num{
            font-size: 0.48rem;
            color: #EE2325;
            line-height: 0.48rem;
          }
        }
        .desc{
          font-family: PingFangSC-Semibold;
          font-size: 0.2rem;
          color: #FA3C3C;
          text-align: center;
          line-height: 0.2rem;
          margin-top: 0.1rem
        }
      }
    }
    .mid{
      margin: 0 1.6rem;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 0.23rem;
      .content{
        .top{
          display: flex;
          justify-content: flex-start;
          margin-top: 0.1rem;
          .tips{
            display: inline-block;
            background: #FEDEDE;
            border-radius: 0.04rem;
            span{
              display: inline-block;
              font-family: PingFangSC-Medium;
              font-size: 0.2rem;
              line-height: 0.28rem;
              color: #EE2325;
              margin: 0.06rem;
            }
          }
          .name{
            margin-left: 0.08rem;
            display: inline-block;
            width: 2.5rem;
            font-family: PingFangSC-Medium;
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #333333;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        .bottom{
          font-family: PingFangSC-Regular;
          font-size: 0.2rem;
          color: #808080;
          margin-top: 0.1rem
        }
      }
    }
    .right{
      float: right;
      width: 1.6rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        width: 1.12rem;
        height: 0.44rem;
        background: #EE2325;
        border-radius: 0.22rem;
        font-family: PingFangSC-Semibold;
        font-size: 0.2rem;
        color: #FFFFFF;
        line-height: 0.44rem;
        text-align: center;
      }
    }
  }
  .isNoData{
    width: 100%;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #ccc;
    text-align: center;
  }
}
</style>
